import { getApiBaseUrl } from '@services/api/axios';

export function getLibraryRawFileUrl(
  uuid: string,
  userId: number | string
): string {
  const base = getApiBaseUrl().replace(/\/$/, '');
  return `${base}/online-library/get-raw-file/${uuid}?user_id=${userId}`;
}
